const nonBlankString = (value) => (
    typeof value === "string" && value.trim() !== "" ? value.trim() : null
);

export const getAccountDeletionCsrfToken = (response) => (
    nonBlankString(response?.csrfToken)
);

export const getAccountDeletionActionGrant = (response) => (
    nonBlankString(response?.reauthToken)
);

export const getAccountDeletionChallengeId = (response) => (
    nonBlankString(response?.challengeId)
);
